/* eslint-disable */
// src/pages/advisory/AdvisoryPage.jsx
import PageTopBar from "components/PageTopBar";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { listAdvisoryPublic } from "services/advisoryPublicService";

function fmtFee(v) {
    const s = String(v ?? "").trim();
    if (!s) return "";
    const onlyNum = s.replace(/[,\s]/g, "");
    if (/^\d+$/.test(onlyNum)) {
        const n = Number(onlyNum);
        if (Number.isFinite(n)) return `${n.toLocaleString("ko-KR")}원`;
    }
    return s;
}

export default function AdvisoryPage() {
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState("");
    const [items, setItems] = useState([]);
    const [selectedId, setSelectedId] = useState("");

    const selected = useMemo(() => {
        const id = String(selectedId || "");
        if (!id) return null;
        return (items || []).find((x) => String(x?.id || "") === id) || null;
    }, [items, selectedId]);

    const reload = async () => {
        try {
            setLoading(true);
            setErr("");
            const rows = await listAdvisoryPublic({ limit: 300 });
            setItems(Array.isArray(rows) ? rows : []);
        } catch (e) {
            console.error("[AdvisoryPage] load failed", e);
            setErr(e?.message || "목록을 불러오지 못했습니다.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        reload();
    }, []);

    const openDetail = (it) => {
        const id = String(it?.id || "");
        if (!id) return;
        setSelectedId(id);
        try {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } catch { }
    };

    const closeDetail = () => {
        setSelectedId("");
        try {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } catch { }
    };

    const feeText = fmtFee(selected?.fee);

    return (
        <Wrap>
          <Sheet>
            <PageTopBar variant="back" label="뒤로가기" />
            <ContentArea>

            {!selected && (
                <TopBar>
                    <TopTitle>자문센터</TopTitle>
                    <TopRight />
                </TopBar>
            )}

            {err ? <ErrBox>{err}</ErrBox> : null}

            {loading ? <Hint>불러오는 중…</Hint> : null}
            {!loading && !err && !items.length ? <Empty>등록된 자문센터가 없습니다.</Empty> : null}

            {!loading && !err && !selected ? (
                <List>
                    {items.map((it) => {
                        const id = String(it?.id || "");
                        const name = String(it?.name || "자문센터");
                        const representative = String(it?.representative || "");
                        const phone = String(it?.phone || "");
                        const field = String(it?.field || "");
                        const intro = String(it?.intro || "");
                        const location = String(it?.location || "");
                        const fee = fmtFee(it?.fee);

                        const imageUrls = Array.isArray(it?.imageUrls) ? it.imageUrls : [];
                        const thumb = String(imageUrls?.[0] || "");

                        return (
                            <Card key={id} role="button" tabIndex={0} onClick={() => openDetail(it)}>
                                <Thumb>
                                    {thumb ? <img src={thumb} alt={name} /> : <span>이미지</span>}
                                    {imageUrls.length > 1 ? <Count>+{imageUrls.length - 1}</Count> : null}
                                </Thumb>

                                <Body>
                                    <Name title={name}>{name}</Name>
                                    <Sub>{intro || "-"}</Sub>

                                    {representative ? (
                                        <MetaRow>
                                            <MetaKey>대표명</MetaKey>
                                            <MetaVal>{representative}</MetaVal>
                                        </MetaRow>
                                    ) : null}

                                    {phone ? (
                                        <MetaRow>
                                            <MetaKey>연락처</MetaKey>
                                            <MetaVal>{phone}</MetaVal>
                                        </MetaRow>
                                    ) : null}

                                    {field ? (
                                        <MetaRow>
                                            <MetaKey>분야</MetaKey>
                                            <MetaVal>{field}</MetaVal>
                                        </MetaRow>
                                    ) : null}

                                    {fee ? (
                                        <MetaRow>
                                            <MetaKey>이용료</MetaKey>
                                            <MetaVal>{fee}</MetaVal>
                                        </MetaRow>
                                    ) : null}

                                    <MetaRow>
                                        <MetaKey>위치</MetaKey>
                                        <MetaVal>{location || "-"}</MetaVal>
                                    </MetaRow>
                                </Body>
                            </Card>
                        );
                    })}
                </List>
            ) : null}

            {!loading && !err && !!selected ? (
                <Detail>
                    <DetailTitle>{String(selected?.name || "") || "자문센터"}</DetailTitle>

                    <Gallery>
                        {(Array.isArray(selected?.imageUrls) ? selected.imageUrls : []).length ? (
                            <GalleryRow>
                                {(selected.imageUrls || []).map((u, idx) => (
                                    <GalleryItem key={`${u}_${idx}`}>
                                        <img src={u} alt="" />
                                    </GalleryItem>
                                ))}
                            </GalleryRow>
                        ) : (
                            <GalleryEmpty>등록된 사진이 없습니다.</GalleryEmpty>
                        )}
                    </Gallery>

                    {String(selected?.representative || "") ? (
                        <Section>
                            <SecTitle>대표명</SecTitle>
                            <SecBody>{String(selected?.representative || "")}</SecBody>
                        </Section>
                    ) : null}

                    {String(selected?.phone || "") ? (
                        <Section>
                            <SecTitle>연락처</SecTitle>
                            <SecBody>{String(selected?.phone || "")}</SecBody>
                        </Section>
                    ) : null}

                    {String(selected?.field || "") ? (
                        <Section>
                            <SecTitle>분야</SecTitle>
                            <SecBody>{String(selected?.field || "")}</SecBody>
                        </Section>
                    ) : null}

                    {String(selected?.education || "") ? (
                        <Section>
                            <SecTitle>학력</SecTitle>
                            <SecBody>{String(selected?.education || "")}</SecBody>
                        </Section>
                    ) : null}

                    {feeText ? (
                        <Section>
                            <SecTitle>자문이용료</SecTitle>
                            <SecBody>{feeText}</SecBody>
                        </Section>
                    ) : null}

                    <Section>
                        <SecTitle>소개</SecTitle>
                        <SecBody>{String(selected?.intro || "") || "-"}</SecBody>
                    </Section>

                    <Section>
                        <SecTitle>혜택</SecTitle>
                        <SecBody>{String(selected?.benefit || "") || "-"}</SecBody>
                    </Section>

                    <Section>
                        <SecTitle>위치</SecTitle>
                        <SecBody>{String(selected?.location || "") || "-"}</SecBody>
                    </Section>

                    <BottomActions>
                        <PrimaryBtn type="button" onClick={closeDetail}>
                            목록으로
                        </PrimaryBtn>
                    </BottomActions>
                </Detail>
            ) : null}
            </ContentArea>
          </Sheet>
        </Wrap>
    );
}

/* ====================== styles ====================== */

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #d7e8ff 0%, #eaf3ff 100%);
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  background: #f7faff;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
`;

const ContentArea = styled.div`
  padding: 14px;
  flex: 1;
`;

const TopBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 20;
  background: #fff;
  padding: 10px 0 12px;
  border-bottom: 1px solid #eef2f7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const TopLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const TopRight = styled.div``;

const TopTitle = styled.div`
  font-size: 16px !important;
  font-weight: 900;
  color: #111827;
`;

const BackBtn = styled.button`
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 10px;
  padding: 8px 10px;
  font-size: 14px !important;
  font-weight: 900;
  cursor: pointer;
`;

const ErrBox = styled.div`
  border: 1px solid #fecaca;
  background: #fff1f2;
  color: #b91c1c;
  border-radius: 12px;
  padding: 10px 12px;
  font-size: 13px !important;
  margin: 12px 0;
`;

const Hint = styled.div`
  font-size: 13px !important;
  color: #6b7280;
  padding: 12px 2px;
`;

const Empty = styled.div`
  font-size: 13px !important;
  color: #6b7280;
  padding: 14px 2px;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 12px;
`;

const Card = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #fff;
  padding: 10px;
  display: grid;
  grid-template-columns: 96px 1fr;
  gap: 10px;
  cursor: pointer;
  overflow: hidden;

  &:active {
    transform: scale(0.998);
  }
`;

const Thumb = styled.div`
  position: relative;
  width: 96px;
  height: 96px;
  border-radius: 12px;
  background: #f3f4f6;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 96px;
    height: 96px;
    object-fit: cover;
    display: block;
  }

  span {
    font-size: 12px !important;
    font-weight: 900;
    color: #9ca3af;
  }
`;

const Count = styled.div`
  position: absolute;
  right: 6px;
  bottom: 6px;
  background: rgba(17, 24, 39, 0.78);
  color: #fff;
  border-radius: 999px;
  padding: 4px 8px;
  font-size: 11px !important;
  font-weight: 900;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

const Name = styled.div`
  font-size: 14px !important;
  font-weight: 900;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Sub = styled.div`
  font-size: 13px !important;
  color: #374151;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
`;

const MetaRow = styled.div`
  display: grid;
  grid-template-columns: 44px 1fr;
  gap: 8px;
  align-items: start;
`;

const MetaKey = styled.div`
  font-size: 12px !important;
  font-weight: 900;
  color: #6b7280;
`;

const MetaVal = styled.div`
  font-size: 12px !important;
  color: #111827;
  line-height: 1.35;
  word-break: break-word;
`;

const Detail = styled.div`
  padding-top: 14px;
`;

const DetailTitle = styled.div`
  font-size: 18px !important;
  font-weight: 900;
  color: #111827;
  margin-bottom: 12px;
`;

const Gallery = styled.div`
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
`;

const GalleryRow = styled.div`
  display: flex;
  gap: 10px;
  padding: 12px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const GalleryItem = styled.div`
  flex: 0 0 auto;
  width: 220px;
  height: 220px;
  border-radius: 14px;
  background: #f3f4f6;
  overflow: hidden;

  img {
    width: 220px;
    height: 220px;
    object-fit: cover;
    display: block;
  }
`;

const GalleryEmpty = styled.div`
  padding: 14px;
  font-size: 13px !important;
  color: #6b7280;
`;

const Section = styled.div`
  margin-top: 12px;
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 14px;
  padding: 12px;
`;

const SecTitle = styled.div`
  font-size: 13px !important;
  font-weight: 900;
  color: #111827;
  margin-bottom: 6px;
`;

const SecBody = styled.div`
  font-size: 13px !important;
  color: #111827;
  line-height: 1.45;
  word-break: break-word;
`;

const BottomActions = styled.div`
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
`;

const PrimaryBtn = styled.button`
  border: 0;
  background: #2563eb;
  color: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 13px !important;
  font-weight: 900;
  cursor: pointer;
`;
